export const HandleInactivityModal: string = 'HandleInactivityModal';
